function checkTouchPositionToSwipe({
  modalContainer,
  touchStartPosition
}: {
  modalContainer: HTMLDivElement;
  touchStartPosition: number;
}): boolean {
  // eslint-disable-next-line no-magic-numbers
  const modalSwipePositionBound = modalContainer.getBoundingClientRect().top + 80;
  const isValidSwipePosition = touchStartPosition < modalSwipePositionBound;

  return isValidSwipePosition;
}

export {checkTouchPositionToSwipe};
